import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { getLocationSubheader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/LocationsRule/hooks/getLocationSubheader';

export interface UseGetLocationRuleSubheader {
  subheader: string;
}

export const useGetLocationRuleSubheader = (): UseGetLocationRuleSubheader => {
  const { watch } = useFormContext<IMealCreditFormFields>();
  const locations = watch('locations');
  const subheader = getLocationSubheader(locations);

  return {
    subheader,
  };
};
